<template>
    <div v-if="visible" class="site-wide-message-wrapper p-d-flex p-jc-center p-ai-center">
        <div class="">
            <SCLabel class="p-mr-2" :text="title" /> <router-link class="link" :to="{ name: 'maintenance' }">learn more</router-link>
        </div>
    </div>
</template>
<script>
import { getFirestoreDB } from '@/lib/firebase';
import { SCLabel } from '@scale-computing/scale-design-framework';
export default {
    components: {
        SCLabel,
    },
    data() {
        return {
            visible: false,
            title: null,
            date: null,
            description: null,
        };
    },
    async created() {
        await this.loadMessage();
        if (this.visible) {
            document.body.classList.add('site-wide-message-injected');
        }
    },
    unmounted() {
        document.body.classList.remove('site-wide-message-injected');
    },
    async mounted() {},
    methods: {
        async loadMessage() {
              const { doc, getDoc } = await import('firebase/firestore');
              const firestoreDB = await getFirestoreDB();
              const snapshot = await getDoc(doc(firestoreDB, 'site-wide-message', 'default'));
              const data = snapshot.data();

              if (data.active) {
                  this.visible = true;
                  this.title = data.title;
                  this.date = data.from;
              } else {
                  this.visible = false;
              }
        },
    },
};
</script>
